import httpRenavamClientGateway from "../infra/httpRenavamClientGateway";
import { DadosVeiculo, Response } from "../models/DadosVeiculoSimplesModel";

export async function getDetailVehicle(
  placa: string,
  renavam: number,
  accessToken?: string
): Promise<Response<DadosVeiculo>> {
  const { data } = await httpRenavamClientGateway.get(
    `/service-renavam/v2/consulta-veiculo-extendido?placa=${placa}&renavam=${renavam}`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "app-key": process.env.APP_KEY || "",
      },
    }
  );
  return data;
}

export async function obterDadosVeiculos(
  accessToken?: string
): Promise<DadosVeiculo[]> {
  const { data } = await httpRenavamClientGateway.get(
    `/service-renavam/v2/meus-veiculos`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "app-key": process.env.APP_KEY || "",
      },
    }
  );
  return data;
}
